'use client';
import { useQuery } from 'react-query';
import { PlaylistProps } from '@osmosis/shared/types/playlist';
import { useFetch } from '../context/FetchProvider';
import { fetchPlaylistByUrl } from '../lib/frontend/playlist';

/**
 * React Query caches each fetched playlist under `['user-playlist', url]`
 * Revisiting a playlist reuses the already-retrieved data instead of
 * re-fetching.
 */
export const useActivePlaylist = (
  url?: string,
  initialData?: PlaylistProps,
): PlaylistProps | undefined => {
  const { get } = useFetch();
  const { data } = useQuery(
    ['user-playlist', url],
    () => (url ? fetchPlaylistByUrl(get, url) : Promise.resolve(null)),
    {
      enabled: Boolean(url) && !initialData,
      initialData,
    },
  );

  return data ?? initialData;
};

export default useActivePlaylist;
